import toast from "./toast.function";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { clearToken, getToken } from "@/functions/token.function";

export const errorResponseHandler = (error: AxiosError): any => {
  if (error.response) {
    const { response } = error;
    if (
      !response.data?.data?.hide &&
      response.data?.status !== 401 &&
      !["The selected slug is invalid."].includes(response.data.message)
    )
      toast.error(response.data.message);
    if (response.data.status === 401) clearToken(error.config.errorRedirect ?? true);
  }
  throw error;
};

export const responseHandler = (response: AxiosResponse): AxiosResponse => {
  return response;
};

export const requestHandler = (
  config: AxiosRequestConfig
): AxiosRequestConfig => {
  config.headers.authorization = `Bearer ${getToken()}`;
  return config;
};
